export enum EventType {
    UNKOWN  = 0,
    BUY     = 1,
    SELL    = 2,
}
